module.exports = __webpack_public_path__ + "static/media/loseSFX.98a93211.mp3";